import React from 'react';
import { useTheme } from '@mui/system';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import {
  Root,
  Step,
  LineContainer,
  Line,
  IconContainer,
  StepNumber,
  iconFontStyle
} from './styles';
import ProgressBarDates from './progress-bar-dates';
import ProgressBarRoute from './progress-bar-destinations';

const StepProgressBar = ({
  completedSteps,
  allSteps,
  startDate,
  endDate,
  origin,
  destination,
  StepbackgroundColor,
  status
}) => {
  const theme = useTheme();

  if (allSteps === 0) return null;

  if (allSteps === 1) {
    const stepCompleted = completedSteps === 1;
    return (
      <>
        <ProgressBarDates
          startDate={startDate}
          endDate={endDate}
          status={status}
          destination={destination}
        />
        <Root>
          <LineContainer>
            <Line
              style={{
                backgroundColor: stepCompleted ?
                  theme.palette.secondary.main : theme.palette.grey[400]
              }}
            />
          </LineContainer>
          <Step>
            <IconContainer style={{ backgroundColor: StepbackgroundColor }}>
              {stepCompleted ? (
                <RadioButtonCheckedIcon color="secondary" style={iconFontStyle} />
              ) : (
                <StepNumber
                  variant="caption"
                  style={{ backgroundColor: StepbackgroundColor }}
                >
                  1
                </StepNumber>
              )}
            </IconContainer>
            <IconContainer style={{ backgroundColor: StepbackgroundColor }}>
              <AllInclusiveIcon
                style={{
                  ...iconFontStyle,
                  color: stepCompleted ?
                    theme.palette.secondary.main : theme.palette.grey[600]
                }}
              />
            </IconContainer>
          </Step>
        </Root>
        <ProgressBarRoute origin={origin} destination={destination} />
      </>
    );
  }

  // Handle general case
  return (
    <>
      <ProgressBarDates
        startDate={startDate}
        endDate={endDate}
        status={status}
        destination={destination}
      />
      <Root>
        <LineContainer>
          {Array.from({ length: allSteps - 1 }).map((_, index) => (
            <Line
              key={index}
              style={{
                backgroundColor: index < completedSteps - 1 ?
                  theme.palette.secondary.main : theme.palette.grey[400]
              }}
            />
          ))}
        </LineContainer>
        <Step>
          {Array.from({ length: allSteps }).map((_, index) => (
            <IconContainer
              key={index}
              style={{ backgroundColor: StepbackgroundColor }}
            >
              {index < completedSteps ? (
                <RadioButtonCheckedIcon
                  style={{ ...iconFontStyle, color: theme.palette.secondary.main }}
                />
              ) : (
                <StepNumber
                  variant="caption"
                  style={{ backgroundColor: StepbackgroundColor }}
                >
                  {index + 1}
                </StepNumber>
              )}
            </IconContainer>
          ))}
        </Step>
      </Root>
      <ProgressBarRoute origin={origin} destination={destination} />
    </>
  );
};

export default StepProgressBar;
